import { useEffect, useRef, useState } from 'react';
import { fieldStyle } from './styles';

const chevron = (
  <svg
    style={{ marginInlineStart: 'auto', flexShrink: 0 }}
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    aria-hidden
  >
    <path d="m6 9 6 6 6-6" />
  </svg>
);

export default function GlassSelect({
  value,
  onChange,
  options = [],
  ariaLabel,
  compact = false,
}) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const selected = options.find((opt) => opt.value === value) || options[0];

  useEffect(() => {
    const onDoc = (event) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  return (
    <div ref={wrapRef} style={{ position: 'relative', width: compact ? 'auto' : '100%' }}>
      <button
        type="button"
        aria-label={ariaLabel}
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        style={{
          ...fieldStyle,
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          cursor: 'pointer',
          textAlign: 'start',
          width: compact ? 'auto' : '100%',
          minWidth: compact ? 72 : undefined,
          height: compact ? 44 : undefined,
          padding: compact ? '0 12px' : fieldStyle.padding,
          background: compact ? 'linear-gradient(160deg, var(--s09), var(--s02))' : fieldStyle.background,
          appearance: 'none',
          boxSizing: 'border-box',
        }}
      >
        <span>{selected?.label}</span>
        {chevron}
      </button>
      {open && (
        <div
          role="listbox"
          style={{
            position: 'absolute',
            top: 'calc(100% + 6px)',
            insetInlineStart: compact ? 'auto' : 0,
            insetInlineEnd: 0,
            minWidth: compact ? 132 : undefined,
            zIndex: 40,
            borderRadius: 14,
            padding: 6,
            background: 'var(--card-solid)',
            border: '1px solid var(--s10)',
            boxShadow: 'inset 0 1px 0 var(--s10), 0 18px 44px var(--sh40)',
          }}
        >
          {options.map((opt) => {
            const on = opt.value === value;
            return (
              <button
                key={opt.value}
                type="button"
                role="option"
                aria-selected={on}
                onClick={() => {
                  onChange(opt.value);
                  setOpen(false);
                }}
                style={{
                  display: 'block',
                  width: '100%',
                  textAlign: 'start',
                  padding: '10px 12px',
                  borderRadius: 10,
                  border: 'none',
                  appearance: 'none',
                  background: on ? 'var(--s08)' : 'transparent',
                  color: 'var(--tx)',
                  fontFamily: 'inherit',
                  fontSize: 13.5,
                  cursor: 'pointer',
                }}
              >
                {opt.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
